import { useEffect, useState, useCallback } from 'react';

const KEY = 'dws_theme';
export const THEMES = [
  { key: 'light',      label: 'Light',      swatch: '#ffffff', ring: '#e5e7eb' },
  { key: 'dark',       label: 'Dark',       swatch: '#0f1419', ring: '#1f2937' },
  { key: 'green',      label: 'Green',      swatch: '#075e54', ring: '#128c7e' },
  { key: 'blue',       label: 'Blue',       swatch: '#1d4ed8', ring: '#3b82f6' },
  { key: 'dark-blue',  label: 'Dark Blue',  swatch: '#0b1a3d', ring: '#1e3a8a' },
];

const ALL_KEYS = THEMES.map(t => t.key);

export function useTheme() {
  const [theme, setThemeState] = useState(() => {
    try { return localStorage.getItem(KEY) || 'light'; } catch { return 'light'; }
  });

  useEffect(() => {
    const root = document.documentElement;
    // remove all theme-* classes first
    ALL_KEYS.forEach(k => root.classList.remove(k === 'light' ? 'theme-light' : `theme-${k}`));
    root.classList.remove('dark');
    // apply the current one
    if (theme === 'dark') root.classList.add('dark');
    root.classList.add(`theme-${theme}`);
    try { localStorage.setItem(KEY, theme); } catch {}
  }, [theme]);

  const setTheme = useCallback((t) => setThemeState(ALL_KEYS.includes(t) ? t : 'light'), []);
  const toggleTheme = useCallback(() => setThemeState(prev => prev === 'dark' ? 'light' : 'dark'), []);

  return { theme, setTheme, toggleTheme };
}
